import dateformat from "dateformat";
import PropTypes from "prop-types";
import React from "react";

export function format(d) {
    const format = mask => dateformat(d, mask);
    const hourDelta = Math.abs(d - Date.now()) / 1000 / 60 / 60;
    if (hourDelta < 11) {
        return format("h:MM tt");
    } else if (hourDelta < 24 * 4) {
        return format("ddd h:MM tt");
    } else if (hourDelta < 24 * 30) {
        return format("mmm d, h:MM tt");
    } else if (hourDelta < 24 * 30 * 6) {
        return format("mmm d");
    } else {
        return format("mmm d, yyyy");
    }
}

const Timestamp = ({
                       ts,
                       className = "",
                   }) => {
    const d = new Date(ts);
    if (d < Date.now()) {
        className += " in-the-past";
    }
    return <span className={`timestamp ${className}`}>{format(d)}</span>;
};

Timestamp.propTypes = {
    ts: PropTypes.instanceOf(Date).isRequired,
    className: PropTypes.string,
};

export default Timestamp;



// WEBPACK FOOTER //
// ./src/util/Timestamp.js